import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { SegmentService } from 'src/app/services/segment/segment.service';

@Component({
  selector: 'app-contact-sales',
  templateUrl: './contact-sales.component.html',
})
export class ContactSalesComponent {
  @Input() linkName: string;
  @Input() buttonText: string;
  @Input() buttonClass = '';
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() contactSalesFlowId: string;
  @Input() eventName: string;
  @Input() location: string;
  @Input() raised = true;
  @Output() chatStarted = new EventEmitter<{ event: MouseEvent, linkName: string }>();

  constructor(
    private readonly growthBookService: GrowthBookService,
    private readonly segment: SegmentService,
    private readonly store: Store,
  ) {}

  openContactSalesLandingPage(event: Event): void {
    event.preventDefault();
    this.trackAddonsLandingPageClick();
    const newWindow = window.open('https://www.timedoctor.com/contact#contact-form', '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  }

  trackAddonsLandingPageClick() {
    this.segment.trackInAppEvents('Link Click',
      {
        linklocation: 'Choose Plan Page',
        linkname: `Contact Sales`,
        linkurl: 'https://www.timedoctor.com/contact',
        pagename: 'new-billing',
        linktype: 'button',
      },
    );
  }
}
